import { List } from "./list";

export const Edit = { List };
